module.exports = __webpack_public_path__ + "img/aci.2e4cef4f.png";